
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Cargo } from '@/models/Cargo'

@Component({})
export default class AdvisingGenerator extends Vue {
	@Prop({ required: true })
	cargo!: Cargo

	comments: string = ''

	selectedLanguage: string | null = null
	locales: Array<string> = ['nl', 'en', 'de', 'fr']

	isDocumentGenerating: boolean = false

	closeDocumentCreator() {
		this.$emit('creator-closed')
	}

	created() {
		this.selectedLanguage = this.$i18n?.locale ?? 'nl'
	}

	async generateDocument() {
		const valid = await this.$validator.validateAll()
		if (!valid) return

		this.isDocumentGenerating = true

		try {
			await this.cargo.doCallbackWithLanguage((httpClient) => {
				return httpClient.post(`${this.cargo!.getModelUrl()}/advising`, {
					data: {
						attributes: {
							comments: this.comments
						}
					}
				})
			}, this.selectedLanguage)

			this.closeDocumentCreator()
		} finally {
			this.isDocumentGenerating = false
		}
	}
}
